var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.672 16.733a7.5 7.5 0 111.161-.96l4.197 4.197a.75.75 0 11-1.06 1.06l-4.297-4.297zM16.5 10.5a6 6 0 11-12 0 6 6 0 0112 0z",
    fill: "currentColor"
  })));
}
SvgSearch.displayName = 'Search';
export default SvgSearch;